/**
 * 渠道房型价格组件取数：前端直调 PMS getRoomPriceByChannel + 本地缓存 2 分钟
 * 先读 localStorage 展示，再按需后台刷新，有缓存时不显示 loading 动画
 */
import { useState, useCallback, useEffect } from 'react';
import { getChannelPriceWithCache, getChannelPriceFromLocalStorageSync } from '../utils/channelPriceCache';
export function useChannelPriceData(storeId, options) {
    var enabled = (options === null || options === void 0 ? void 0 : options.enabled) !== false;
    var _a = useState(function () {
        return enabled ? getChannelPriceFromLocalStorageSync(storeId) : null;
    }), data = _a[0], setData = _a[1];
    var _b = useState(function () { return enabled && !getChannelPriceFromLocalStorageSync(storeId); }), loading = _b[0], setLoading = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var _d = useState(0), refreshKey = _d[0], setRefreshKey = _d[1];
    var refresh = useCallback(function () {
        setRefreshKey(function (k) { return k + 1; });
    }, []);
    useEffect(function () {
        if (!enabled) {
            setLoading(false);
            setError(null);
            setData(null);
            return;
        }
        var cancelled = false;
        if (!getChannelPriceFromLocalStorageSync(storeId))
            setLoading(true);
        setError(null);
        getChannelPriceWithCache(storeId)
            .then(function (res) {
            if (!cancelled) {
                setData(res !== null && res !== void 0 ? res : null);
                setError(null);
            }
        })
            .catch(function (err) {
            if (!cancelled) {
                setError(err instanceof Error ? err : new Error(String(err)));
                setData(null);
            }
        })
            .finally(function () {
            if (!cancelled)
                setLoading(false);
        });
        return function () {
            cancelled = true;
        };
    }, [storeId, refreshKey, enabled]);
    return { data: data, loading: loading, error: error, refresh: refresh };
}
